const InsuranceChallenge2Dataset = {
    items: {
        "item-1": { id: "item-1", content: "Before choosing a plan, compare the monthly premium " +
                        "against the deductible. A cheap premium isn't always the best deal.", 
                answer: "column-2" },
        "item-2": { id: "item-2", content: "You don't need car insurance if you're a good driver. " +
                "Accidents won't happen to you.", 
                answer: "column-3" },
        "item-3": { id: "item-3", content: "Just lie on your insurance application to get a lower " +
                "rate.  They'll never find out.",
                answer: "column-3" },
        "item-4": { id: "item-4", content: "A higher deductible usually means a lower monthly premium.",
                answer: "column-2" },
        "item-5": { id: "item-5", content: "Even if your landlord doesn't require it, renters insurance " +
                "is worth getting. It's usually less than $20 a month. " , 
                answer: "column-2" },
        "item-6": { id: "item-6", content: "Always buy the cheapest insurance you can.", 
                answer: "column-3" },   
        "item-7": { id: "item-7", content: "When you turn 26, you'll need your own health insurance plan " + 
                "Don't wait until the last minute to figure it out.", 
                answer: "column-2" },   
        "item-8": { id: "item-8", content: "Shop around and get quotes from at least three insurance companies " +
                "before you commit to one.", 
                answer: "column-3" }
    },

    columns: {
        "column-1": { id: "column-1", title: "Insurance Advice", 
            itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6", "item-7", "item-8"] },
        "column-2": { id: "column-2", title: "Advice that is Good", itemIds: [] },
        "column-3": { id: "column-3", title: "Advice that is Not Good", itemIds: []},
       
    },

    columnOrder: ["column-1", "column-2", "column-3"]
}

export default InsuranceChallenge2Dataset